export default __webpack_public_path__ + "static/media/infoIcon.dbdcbc0f.svg";